import {
  Card,
  CardContent,
  CardHeader,
  FormControl,
  FormHelperText,
  Icon,
  IconButton,
  Input,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from '@material-ui/core';
import ModalActions from 'components/ModalActions';
import { Field, Formik } from 'formik';
import { functions } from 'helpers/functions';
import React from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { listDeliveryProvider } from 'store/Orbita/DeliveryProviders/actions';
import UrlValidationFormField from 'v2/components/Shared/UrlValidationFormField';
import deliveryProvidersService from 'v2/services/delivery-providers';
import { isUrl } from 'validations/rules';
import * as yup from 'yup';

import type { TestResult } from 'v2/interfaces/delivery-providers';

import type { DispatchProp } from 'react-redux';

interface IProps extends DispatchProp<any> {
  others: any[];
  isModal: boolean;
  open?: boolean;
  onClose?: any;
  onOk: any;
  other?: any;
  offer?: any;
  newProduct?: boolean;
  alphaclass?: boolean;
  hasHotmart?: boolean;
  deliveries?: any;
}

interface IStates {
  selected: any;
  parameters: any[];
  fields: any;
  defaultFields: any;
  pinParameters: any;
  open: boolean;
  inputSelected: any;
  isCustomProviderUrlValid: boolean;
}

const HOTMART_PROVIDER_ID = 4;
const CUSTOM_PROVIDER_ID = 1;
const LEADLOVERS_PROVIDER_ID = 12;
const EADPLATAFORMA_PROVIDER_ID = 29;
const APOLLO_PROVIDER_ID = 39;

class Other extends React.Component<IProps, IStates> {
  constructor(props: IProps) {
    super(props);
    this.props.dispatch(listDeliveryProvider(this.props.newProduct));
    this.state = {
      selected: '',
      inputSelected: '',
      parameters: null,
      open: this.props.open,
      pinParameters: null,
      fields: {},
      defaultFields: {},
      isCustomProviderUrlValid: false,
    };
  }

  handleChange = (event: any) => {
    const others = this.props.others;
    if (!others?.length) return;
    const id = event.target.value;
    const otherDelivery = others.find((i) => i.id === id);
    let newSelected: any = { ...otherDelivery };

    newSelected.method_id = `${newSelected.id}`;
    newSelected.method_name = newSelected.name;
    this.setState({
      selected: newSelected,
      parameters: newSelected.parameters,
      inputSelected: id,
      fields: newSelected,
      isCustomProviderUrlValid: false,
    });
  };

  handleOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    if (this.state.parameters) this.state.parameters.map((p) => this.onChangeProp(p.name, this.state.defaultFields[p.name]));
    this.props.onClose();
    this.setState({ open: false });
  };

  handleOk = () => {
    const onOk = this.props.onOk;
    const { fields, parameters, selected } = this.state;
    let newFields = { ...fields };
    let msg = '';
    let isValid = true;

    if (fields && fields.id === 9) {
      const { pinParameters } = this.state;
      newFields = Object.assign(fields, pinParameters);

      if (fields) {
        isValid = false;
        this.props.onClose();
      }
    } else {
      for (let prop in parameters) {
        let propName = parameters[prop].name;
        let label = parameters[prop].label;

        if (fields[propName] && fields[propName] !== '' && isValid) {
          if (propName.includes('url')) {
            if (isUrl(fields[propName])) {
              isValid = false;
              msg = `Por favor informe uma Url válida no campo ${label}`;
            } else {
              isValid = true;
            }
          } else {
            isValid = true;
          }
        } else {
          isValid = false;
          if (!msg) {
            msg = `Por favor preencha o campo ${label}`;
          }
          break;
        }
      }
    }

    if (fields && fields.id) {
      if (isValid) {
        if (onOk) {
          if (functions.isEqual(fields, selected)) {
            return this.props.onClose();
          }

          newFields.new = true;
          newFields.can_modify = true;
          const alreadyExistsUrl = this.props.deliveries?.findIndex((delivery: any) => delivery.url === fields.url) !== -1;
          if (alreadyExistsUrl) {
            toast.warn('URL já adicionada');
            msg = '';
            return;
          }
          this.setState({ fields: newFields });
          onOk(newFields, this.state.defaultFields);

          if (!this.props.other) {
            toast.success(`Item ${fields.name} adicionado com sucesso!`);
          }
          this.setState({ selected: '', parameters: null, pinParameters: null, inputSelected: '' });
        }
      } else {
        toast.warn(`${msg}`);
        msg = '';
      }
    } else {
      toast.warn('Por favor selecione uma forma de entrega do tipo outros');
    }
  };

  onChangePin = (field: any, value: any) => {
    let pinParameters = this.state.pinParameters || {};
    pinParameters[field] = value;
    this.setState({ pinParameters });
  };

  onChangeProp = (propName: any, value: any) => {
    const fields = { ...this.state.fields };
    fields[propName] = value;
    this.setState({ fields });
  };

  componentDidMount() {
    const nextProps = this.props;
    if (nextProps.other) {
      let parameters =
        nextProps.others && nextProps.others.length && nextProps.others.filter((item: any) => item.id === parseInt(nextProps.other.method_id))[0];
      parameters = parameters && parameters.parameters;
      this.setState({
        selected: nextProps.other,
        inputSelected: parseInt(nextProps.other.method_id),
        parameters,
        fields: nextProps.other,
      });

      this.setState({ defaultFields: { ...nextProps.other } });
    }
  }

  isOkButtonDisabled = () => {
    const { inputSelected } = this.state;
    const providersWithUrl = [CUSTOM_PROVIDER_ID, APOLLO_PROVIDER_ID, EADPLATAFORMA_PROVIDER_ID, LEADLOVERS_PROVIDER_ID];
    if (providersWithUrl.includes(inputSelected)) {
      return !this.state.isCustomProviderUrlValid;
    }
    return false;
  };

  urlForm(paramName: string, validateUrlCallback: (url: string) => Promise<TestResult>, initialValue: string = '') {
    return (
      <Formik
        key={paramName}
        initialValues={{
          url: initialValue,
          type: 'invoice',
        }}
        validationSchema={yup.object().shape({
          url: yup
            .string()
            .required('Preencha o campo URL, obrigátorio http:// ou https://')
            .url('Insira uma URL válida, obrigátorio http:// ou https://'),
        })}
        onSubmit={(values) => alert(JSON.stringify(values, null, 2))}
      >
        <div style={{ marginTop: 16 }}>
          <Field
            name='url'
            helperText='Insira uma URL válida, obrigátorio http:// ou https://'
            component={UrlValidationFormField}
            onValidateUrl={(isValid: boolean, url: string) => {
              this.onChangeProp(paramName, url);
              this.setState({ isCustomProviderUrlValid: isValid });
            }}
            validateUrlCallback={validateUrlCallback}
            helpLink='https://github.com/eduzz/custom-delivery'
          />
        </div>
      </Formik>
    );
  }

  render() {
    const { others, isModal, open, hasHotmart } = this.props;
    const { parameters, fields, inputSelected } = this.state;
    const filteredOthers = Array.isArray(others)
      ? others.filter((o) => {
          if (o.id === HOTMART_PROVIDER_ID && !hasHotmart) return false;
          if (o.id === 47) return false;
          return true;
        })
      : [];

    const content = (
      <form>
        <FormControl style={{ width: '100%' }}>
          <InputLabel shrink htmlFor='nutror'>
            Selecione um outro tipo de entrega
          </InputLabel>
          <Select input={<Input />} disableUnderline inputProps={{ disableUnderline: true }} value={inputSelected} onChange={this.handleChange}>
            {filteredOthers.map((item: any) => (
              <MenuItem key={`other-${item.id}`} value={item.id}>
                {item.name}
              </MenuItem>
            ))}
          </Select>
          {parameters?.map((param: any) => {
            if (inputSelected === CUSTOM_PROVIDER_ID && param.name?.includes('url')) {
              return this.urlForm(param.name, deliveryProvidersService.customTestUrl, fields[param.name] || '');
            }
            if (inputSelected === LEADLOVERS_PROVIDER_ID && param.name?.includes('url')) {
              return this.urlForm(param.name, deliveryProvidersService.leadloversTestUrl, fields[param.name] || '');
            }
            if (inputSelected === EADPLATAFORMA_PROVIDER_ID && param.name?.includes('url')) {
              return this.urlForm(param.name, deliveryProvidersService.customTestUrl, fields[param.name] || '');
            }
            if (inputSelected === APOLLO_PROVIDER_ID && param.name?.includes('url')) {
              return this.urlForm(param.name, deliveryProvidersService.apolloTestUrl, fields[param.name] || '');
            }
            return (
              <React.Fragment key={param.name}>
                <TextField
                  key={`parameter-${param.name}`}
                  id={param.name}
                  label={param.label}
                  onChange={(e: any) => this.onChangeProp(param.name, e.target.value)}
                  value={fields[param.name]}
                  margin='normal'
                  InputProps={{
                    disableUnderline: true,
                  }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
                {param && param.hint && <FormHelperText>{param.hint}</FormHelperText>}
              </React.Fragment>
            );
          })}
        </FormControl>
      </form>
    );
    return (
      <div>
        {isModal ? (
          <ModalActions
            buttonOk='Salvar'
            title={'Entrega de Conteúdo'}
            open={open}
            onClose={this.handleClose}
            onOk={this.handleOk}
            buttonOkDisabled={this.isOkButtonDisabled()}
          >
            {content}
          </ModalActions>
        ) : (
          <Card>
            <CardHeader
              title='Entrega de Conteúdo'
              action={
                <IconButton>
                  <Icon>clear</Icon>
                </IconButton>
              }
            />
            <CardContent>{content}</CardContent>
          </Card>
        )}
      </div>
    );
  }
}

function mapStateToProps(state: any) {
  return {
    others: state.orbita.DeliveryProvider.list,
  };
}

export default connect(mapStateToProps)(Other);
